import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../themes/redesignTokens";

// ═══════════════════════════════════════════════════════════════
//  MIDAS Design Tokens (local subset)
// ═══════════════════════════════════════════════════════════════


const midas = {
  gold: "#D4A017",
  goldDark: "#A67C00",
  goldSoft: "rgba(212, 160, 23, 0.08)",
};

// ═══════════════════════════════════════════════════════════════
//  ChatSuggestionChips
// ═══════════════════════════════════════════════════════════════

interface ChatSuggestionChipsProps {
  suggestions: string[];
  onChipClick: (text: string) => void;
  isPhone?: boolean;
}

const ChatSuggestionChips: React.FC<ChatSuggestionChipsProps> = ({
  suggestions,
  onChipClick,
  isPhone = false,
}) => {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        flexWrap: "nowrap",
        overflowX: "auto",
        padding: "8px 0 4px 36px",
        maxWidth: "100%",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {suggestions.map((text, index) => (
        <Box
          key={index}
          onClick={() => onChipClick(text)}
          sx={{
            background: "transparent",
            border: "1.5px solid rgba(212, 160, 23, 0.35)",
            borderRadius: "20px",
            padding: "6px 14px",
            fontFamily: dt.font,
            fontSize: isPhone ? "13px" : "12px",
            fontWeight: 500,
            color: dt.textSecondary,
            whiteSpace: "nowrap",
            cursor: "pointer",
            flexShrink: 0,
            transition: "all 0.2s ease",
            animation: `midasChipStagger 0.2s cubic-bezier(0.4, 0, 0.2, 1) ${index * 50}ms both`,
            "&:hover": {
              background: midas.goldSoft,
              borderColor: midas.gold,
              color: midas.goldDark,
              transform: "translateY(-1px)",
            },
          }}
        >
          {text}
        </Box>
      ))}
    </Box>
  );
};

export default ChatSuggestionChips;
